import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
export const IconCloseLarge = forwardRef<HTMLElement, IconProps>(
    (props, ref) => (
        <Icon ref={ref} {...props}>
            <path
                fill="#111928"
                fillRule="evenodd"
                d="m6 4 6 6 6-6 2 2-6 6 6 6-2 2-6-6-6 6-2-2 6-6-6-6z"
                clipRule="evenodd"
            />
        </Icon>
    )
);
IconCloseLarge.displayName = "IconCloseLarge";
